import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import Sidebar from 'Components/Sidebar';
import DashboardTopNav from 'Components/DashboardTopNav';
import AllRfqs from 'Components/AllRfqs/index';
import { GET_RFQS, CLEAR_RFQS, COPY_RFQ, PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE, PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE, GET_RFQ_TYPES, GET_AMMENDMENT_LIST_DATA, PUT_AMMENDMENT_APPROVE_DATA, DOWNLOAD_TRUCKS, UPLOAD_NUMBER_OF_TRUCKS } from 'Constants/actionConstants';
import Moment from 'moment';
import { getDashboardActiveView, setDashboardActiveView, getUser, storeToken, storeCompanyType, storeUser, storeCompanyId, getToken } from 'Utils/storage';
import ApprovalMatrix from 'Components/ApprovalMatrix/index';
import RFQBottomSticky from 'Components/RFQBottomSticky/index';
import { LOGIN_WITH_SSO } from 'Constants/actionConstants';
import { ROQUETTE } from 'Constants/commonConstants';
import { getItemFromSessionStorage, setItemToSessionStorage } from 'Utils/sessionStorage';
import { isDesmetSupplier } from 'Utils/index';

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.user = getUser();
        this.state = {
            rfqStatusFilter : getDashboardActiveView() || 2,
            searchString: "",
            offset:  !!getItemFromSessionStorage("rfqOffset")?getItemFromSessionStorage("rfqOffset"):0,
            limit: 10,
            data: props.rfqs.data || [],
            startDate:0,
            endDate:0,
            rfqType: '',
            ammendmentId: [],
            isSSO: false,
            disableUploadTrucks: true
        }
        this.onRfqSearchByDate = this.onRfqSearchByDate.bind(this);
        this.changeRfqStatusFilter = this.changeRfqStatusFilter.bind(this);
        this.onSearchStringChange = this.onSearchStringChange.bind(this);
        this.onKeyPressOnSearch = this.onKeyPressOnSearch.bind(this);
        this.onClearSearch = this.onClearSearch.bind(this);
        this.search = this.search.bind(this);
        this.goToNextPage = this.goToNextPage.bind(this);
        this.goToPrevPage = this.goToPrevPage.bind(this);
    }
    getRFQTimer = null;
    search(withOffset) {
        if(this.unmounted) {return};
        if(this.getRFQTimer) {
            clearTimeout(this.getRFQTimer)
        }
        const { dispatch } = this.props;
        const { offset, limit, rfqStatusFilter, searchString ,startDate, endDate, rfqType, rfqActiveStatus, branchId, biddingType, user, contractType} = this.state
        const isRoquette = ROQUETTE.includes(getUser().companyId);
        if(rfqStatusFilter === 20 || rfqStatusFilter === 21 || rfqStatusFilter === 22) {
            dispatch({
                type: GET_AMMENDMENT_LIST_DATA,
                params: {
                    companyId: this.user.companyId,
                    status: rfqStatusFilter === 20 ? 2 : rfqStatusFilter === 21 ? 1 : 3,
                    level: this.user.ammendmentLevel
                },
                onSuccess: this.setGetRFQTimer,
                onError: this.setGetRFQTimer,
            });
        } else {
            dispatch({
                type: GET_RFQS,
                params: {
                    offset: withOffset > 0 ? offset : 0,
                    limit: limit,
                    type: rfqStatusFilter,
                    search: searchString,
                    from: Moment(startDate).valueOf(),
                    to: Moment(endDate).valueOf(),
                    rfqType,
                    isSpotContract: getUser().isSpotContract,
                    branchId: (isRoquette && [5, 9].includes(rfqStatusFilter)) ? branchId : undefined,
                    rfqActiveStatus: (isRoquette && [5, 9].includes(rfqStatusFilter)) ? rfqActiveStatus : undefined,
                    biddingType: (isRoquette && [5, 9].includes(rfqStatusFilter)) ? biddingType : undefined,
                    user,
                    contractType: (isRoquette && [5, 9].includes(rfqStatusFilter)) ? contractType : undefined
                },
                onSuccess: this.setGetRFQTimer,
                onError: this.setGetRFQTimer,
            });
        }
    }
    setGetRFQTimer = ()=> {
        const timerLimit = this.state.rfqStatusFilter === 5 ? 30000 : 10000;
        this.getRFQTimer = setTimeout(()=> {
            this.search(this.state.offset)
        }, timerLimit);
    }
     onRfqSearchByDate=(startDate, endDate)=>{
        this.setState({
            startDate,
            endDate
        },()=>{
            this.search(this.state.offset);
        })
        }
        onClearDate=()=> {
            this.setState({
                startDate:0,
                endDate:0
            }, this.search);
        }

    changeRfqStatusFilter(value) {
        const { dispatch }= this.props;
        if(value === 19) {

        } else {
            dispatch({
                type: CLEAR_RFQS
            });
            this.setState({rfqStatusFilter: value}, () => {
                this.setState({offset: 0, limit: 10}, () => {
                    this.search();
                });
            });
            setDashboardActiveView(value);
        }
    }

    goToNextPage() {
        this.setState({
            offset: this.state.offset + this.state.limit
        }, () => {
            this.search(this.state.offset);
        });
    }

    onRFQTypeSelect = (value) => {
        this.setState({
            rfqType: value.id
        },this.search);
    }

    onSelect = (key, option) => {
        this.setState({
            [key]: option.value
        },this.search);
    }

    // renderPaginationButtons = () => {
    //     const { offset, limit, rfqs } = this.state;
    //     const {loiCount}=this.props.rfqs
    
    //     const totalPages = Math.ceil(loiCount / limit);
    
    //     const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    
    //     return (
    //         <div className='flex flex-middle' >
    //          {pageNumbers.map((pageNumber) => (
    //                 <button
    //                     key={pageNumber}
    //                     className={classNames("pagination-button", { active: (pageNumber - 1) * limit === offset })}
    //                     onClick={() => this.goToPage(pageNumber)}
    //                 >
    //                     {pageNumber}
    //                 </button>
    //             ))}
    //         </div>
    //     );
    // }
    renderPaginationButtons = () => {
        const { offset, limit } = this.state;
        const { loiCount } = this.props.rfqs;
    
        const totalPages = Math.ceil(loiCount / limit);
        const currentPage = Math.floor(offset / limit) + 1;
    
        // Calculate the range of page numbers to display
        const startPage = Math.max(1, currentPage - 2);
        const endPage = Math.min(totalPages, startPage + 4);
    
        // Generate an array of page numbers within the range
        const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);
    
        return (
            <div className='flex flex-middle'>
                <button
                    className="pagination-button"
                    onClick={() => this.goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    {'<'}
                </button>
    
                {pageNumbers.map((pageNumber) => (
                    <button
                        key={pageNumber}
                        className={classNames("pagination-button", { active: (pageNumber - 1) * limit === offset })}
                        onClick={() => this.goToPage(pageNumber)}
                    >
                        {pageNumber}
                    </button>
                ))}
    
                <button
                    className="pagination-button"
                    onClick={() => this.goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                >
                    {'>'}
                </button>
            </div>
        );
    }

    goToPage = (pageNumber) => {
        const {dispatch}=this.props;
        const { limit } = this.state; 
        const newOffset = (pageNumber - 1) * limit;
        this.setState({
            offset: newOffset,
        }, () => {
            setItemToSessionStorage("rfqOffset",newOffset)
            this.search(this.state.offset);
        });
       
    }

    goToPrevPage() {
        if(this.state.offset != 0) {
            this.setState({
                offset: this.state.offset - this.state.limit
            }, () => {
                this.search(this.state.offset);
            });
        }
    }

    onSearchStringChange(e) {
        this.setState({
            searchString: e.currentTarget.value,
            offset: 0,
            limit: 10
        }, this.search);
    }

    onClearSearch() {
        this.setState({
            searchString: '',
        }, this.search);
    }

    onKeyPressOnSearch(e) {
        if(e.which == 13) {
            // this.setState({offset: 0, limit: 10}, () => {
            //     this.search();
            // });
        }
    }
    pickupDraft = (rfq)=> {
        const { history } = this.props;
        history.push("/rfq/create/" + rfq.id + "/" + rfq.type);
    }
    navigateRFQBids = (rfq)=> {
        const { history } = this.props;
        history.push("/seeker/bids/" + rfq.id + "/" + rfq.type);
    }
    navigateRFQView = (rfq)=> {
        const { history } = this.props;
        history.push("/rfq/view/" + rfq.id + "/" + rfq.serviceType + "/" + rfq.type);
    }
    navigateTK11RFQBids = (rfq) => {
        const {history} = this.props;
        history.push("/tk11Dashboard/" + rfq.id);
    }
    copyRFQ = (id, rfqType)=>{
        const { dispatch } = this.props;
        dispatch({
            type: COPY_RFQ,
            params: {
                rfq_id: id,
                rfqType
            }
        })
    }
    componentDidMount() {
        const { dispatch ,history} = this.props;
        let url = window.location.href;
        let params = url.split("?");
        let userData = {};
        const isSSOUser = localStorage.getItem('isSSOUser');
        const SSOSessionSaved = localStorage.getItem('teg-sso-session');
        const isToken = getToken();
        if(params && params.length > 1 && !isToken){
            let objects = params[1].split("&");
            (objects || []).map((obj) => {
            let data = obj.split("=");
            if(['company_type'].includes(data[0])){
                userData[data[0]] = Number(data[1]);
            } else {
                userData[data[0]] = data[1];
            }
            if(data[0] === "token"){
                storeToken(data[1]);
            }
            else if(data[0] === "company_type"){
                storeCompanyType(Number(data[1]));
            }
            else if(data[0] === "company_id"){
                storeCompanyId(data[1]);
            }
            })
        }
        if(isSSOUser == 'true' && SSOSessionSaved !== 'true'){
            dispatch({
            type: LOGIN_WITH_SSO,
            onSuccess: () => {
                dispatch({
                    type: CLEAR_RFQS
                });
                dispatch({
                    type: GET_RFQ_TYPES
                })
                this.search();
                localStorage.setItem('teg-sso-session', true);
            }
            })
        } else {
            dispatch({
                type: CLEAR_RFQS
            });
            dispatch({
                type: GET_RFQ_TYPES
            })
            this.search(this.state.offset);
        }
        
        if(isDesmetSupplier()){
            history.push('/contracting/generic/supplierDashboard')
        }
    }
            
    componentWillUnmount() {
        this.unmounted = true;
        if(this.getRFQTimer) {
            clearTimeout(this.getRFQTimer);
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.rfqs.data !== this.props.rfqs.data) {
            this.setState({
                data: nextProps.rfqs.data || []
            })
        }
    }
	uploadServiceCategory = (file) => {
		const { dispatch } = this.props;
		dispatch({
			type: PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE,
			file: file
		})

	}

    approveRejectAmmendment = (data) => {
        const {dispatch} = this.props;
        dispatch({
            type: PUT_AMMENDMENT_APPROVE_DATA,
            params: data,
            onSuccess: this.search
        })
    }

    downloadTrucksDetails = ()=>{
        const { startDate, endDate} = this.state;
        const { dispatch, match } = this.props;

        if(startDate && endDate){
        dispatch({
            type: DOWNLOAD_TRUCKS,
			params: {
				type: 1,
				from: Moment(startDate).valueOf(),
                to: Moment(endDate).valueOf(),
            },
            onSuccess: (data) => {
				this.setState({
                    downloadTrucksDetailsUrl: data.link,
                    disableUploadTrucks: false
				}, () => {
					this.downloadBiddingDetailsButton.click();
				})
			}
        });
    }else{
        alert("Please Select Start Date and End Date");
    }
    }

    uploadNumberOfTrucks =(file)=>{
        const { dispatch, match } = this.props;
        const { disableUploadTrucks } = this.state;
         if (!disableUploadTrucks){
		dispatch({
			type: UPLOAD_NUMBER_OF_TRUCKS,
			file ,
			params: {
				type: 1
            },
            onSuccess: () => {
				this.setState({
                    disableUploadTrucks : true
                })
            }
        });
    }else{
        alert("Please Download New Trucks details Excel file");
    }
	}

    onSelect = (key, option) => {
        this.setState({
            [key]: option.value
        },this.search);
    }
	

    render() {
        const { gettingRfqs, activeCount, biddingCount, loiCount ,rfqApprovedCount, rfqApproverPendingCount, rfqApproverApproved, closePendingCount, loi_contract_count, rfqDPHApproverPendingCount, rfqDPHApprovedCount, rfqDPHApproverApprovedCount, user_name_list } = this.props.rfqs;
        const { limit, offset, rfqStatusFilter, data, rfqType, rfqActiveStatus, branchId, biddingType, user, contractType } = (this.state || {});
        const { creatingRFQ, systemTime, rfqTypesList, loader, ammendmentData, ammendmentCount, branchesList } = this.props;
        this.user = getUser();
        let commontabFilter = [{
                id:2,
                value: 'All Active',
                count: activeCount
            }
        ];

        let extraTabFilters = [];

        extraTabFilters = [
            {
                id:3,
                value: 'Bidding In Progress',
                count: biddingCount
            },{
                id:5,
                value: 'Closed',
                count: loiCount
            }
        ];

        if(['737'].includes(this.user.companyId)) {
            extraTabFilters = [
                {
                    id:3,
                    value: 'Bidding In Progress',
                    count: biddingCount
                },
                {
                    id:8,
                    value: 'LOI/CP Stage',
                    count: closePendingCount
                },
                {
                    id:5,
                    value: 'Closed',
                    count: loiCount
                }
            ]
        } 
        else if(ROQUETTE.includes(this.user.companyId)) {
            extraTabFilters = [
                {
                    id:3,
                    value: 'Bidding In Progress',
                    count: biddingCount
                },
                {
                    id:5,
                    value: 'Closed',
                    count: loiCount
                },
                {
                    id: 9,
                    value: 'LOI',
                    count: loi_contract_count || 0
                }
            ]
        }

        const approvalTabFilters = [{
            id: 12,
            value: 'Approved LOI List',
            count: rfqApprovedCount
        },
        {
            id: 13,
            value: 'Approver Approved',
            count: rfqApproverApproved
        },
    ];

    const approvalMatrixTabFilters = [{
        id: 21,
        value: 'Approved',
        count: ammendmentCount.approved
    },
    {
        id: 22,
        value: 'Rejected',
        count: ammendmentCount.rejected
    },
];
        

        // TODO: Temp fix. Do it better because filter is not making sense here!
        if(rfqStatusFilter === 1) {
            commontabFilter = [{
                id:1,
                value: 'All Drafts',
                count: data && data.length
            }]
        } else if (rfqStatusFilter === 99) {
            commontabFilter = [{
                id: 99,
                value: 'All Cancelled RFQS',
                count: data && data.length
            }];
        } else if (rfqStatusFilter === 11) {
            commontabFilter = [{
                id: 11,
                value: 'TK 11 Status Dashboard',
                count: data && data.length
            }];
        }
        else if(rfqStatusFilter === 10 || rfqStatusFilter === 12 || rfqStatusFilter === 13) {
            commontabFilter = [{
                id:10,
                value: 'Approval Pending',
                count: rfqApproverPendingCount
            }];
        }
        else if(rfqStatusFilter === 20 || rfqStatusFilter === 21 || rfqStatusFilter === 22){
            commontabFilter = [{
                id:20,
                value: 'Awaiting Approval',
                count: ammendmentCount.pending
            }];
        }
        
        let tabFilter = [];
        if (rfqStatusFilter === 10 || rfqStatusFilter === 12 || rfqStatusFilter === 13) {
            tabFilter = commontabFilter.concat(approvalTabFilters);
        } 
        else if(rfqStatusFilter === 20 || rfqStatusFilter === 21 || rfqStatusFilter === 22){
            tabFilter = commontabFilter.concat(approvalMatrixTabFilters);
        } else if([71,72,73].includes(rfqStatusFilter)) {
            tabFilter = [
                {
                    id: 71,
                    value: 'Approval Pending',
                    count: rfqDPHApproverPendingCount
                },
                {
                    id: 72,
                    value: 'Approved DPH List',
                    count: rfqDPHApprovedCount
                },
                {
                    id: 73,
                    value: 'Approver Approved',
                    count: rfqDPHApproverApprovedCount
                }
            ]
        }
        else{

            if(this.user.contracting)
                tabFilter = (rfqStatusFilter === 1 || rfqStatusFilter === 99 || rfqStatusFilter === 11 ) ? commontabFilter : commontabFilter.concat(extraTabFilters); 
        }
        

        
        const searchPlaceHolder = rfqStatusFilter !== 6 ? "Search RFQ" : "Search Contracts";
        const showFilters = rfqStatusFilter !== 6;
        const isSSOUser = localStorage.getItem('isSSOUser');
        const SSOSessionSaved = localStorage.getItem('teg-sso-session');
        
        return (
            <div>
                {
                    // data.length === 0 && ((tabFilter.length === 1 && tabFilter[0].count === 0) ||
                    //     (tabFilter.length === 2 && tabFilter[0].count !== 0 && tabFilter[1].count !== 0) ||
                    //     (tabFilter.length === 3 && tabFilter[0].count !== 0 && tabFilter[1].count !== 0 && tabFilter[2].count !== 0)) &&
                    // <ActionLoader fixed={true} />
                }
                {
                    (gettingRfqs === true || loader) && <ActionLoader fixed={true} />
                }
                {((isSSOUser == 'true') ? ((SSOSessionSaved == 'true') && Object.keys(this.user).length > 0) : true) &&
                    
                <Sticky>
                    <DashboardTopNav 
                    rfqStatusFilter={rfqStatusFilter} 
                    changeRfqStatusFilter={this.changeRfqStatusFilter}
                    tabFilter={tabFilter}
                    searchString={this.state.searchString}
                    onSearchStringChange={this.onSearchStringChange}
                    onKeyPressOnSearch={this.onKeyPressOnSearch}
                    onCancel={this.onClearSearch}
                    searchPlaceHolder={searchPlaceHolder}
                    showFilters={showFilters}
                    onRfqSearchByDate ={this.onRfqSearchByDate}
                    onCancelDate ={ this.onClearDate}
                    contracting={this.user.contracting}
                    />
                    
                    <div className="flex pt-80">
                        
                        <Sidebar  
                            rfqStatusFilter={rfqStatusFilter} 
                            changeRfqStatusFilter={this.changeRfqStatusFilter} 
                            broadcastMsgs={this.props.broadcastMsgs}
                        />
                        
                        <div className="flex-basis-20p" />
                        <div className="fluid-container ml-20">
                        {                         
                            this.user.contracting && 
                            <Fragment>
                               { rfqStatusFilter!== 20 && rfqStatusFilter!== 22  && rfqStatusFilter!== 21 ? <AllRfqs rfqs={data}  
                                status={this.state.rfqStatusFilter}
                                goToNextPage={this.goToNextPage}
                                goToPrevPage={this.goToPrevPage}
                                limit={limit}
                                offset={offset}
                                renderPaginationButtons={this.renderPaginationButtons()}
                                loiCount={loiCount}
                                pickupDraft = {this.pickupDraft}
                                copyRFQ={this.copyRFQ}
                                navigateRFQBids={this.navigateRFQBids}
                                navigateRFQView={this.navigateRFQView}
                                navigateTK11RFQBids={this.navigateTK11RFQBids}
                                gettingRfqs={gettingRfqs}
                                systemTime={systemTime}
								downloadServiceCategory={this.downloadServiceCategory}
                                downloadUrl={this.state.downloadUrl}
                                uploadServiceCategory={this.uploadServiceCategory}
								changeRfqStatusFilter={this.changeRfqStatusFilter} 
                                rfqTypesList={rfqTypesList}
                                rfqType={rfqType}
                                onRFQTypeSelect={this.onRFQTypeSelect}
                                downloadTrucksDetails = { this.downloadTrucksDetails}
                                uploadNumberOfTrucks = {this.uploadNumberOfTrucks}
                                disableUploadTrucks = {this.state.disableUploadTrucks}
                                branchesList={branchesList}
                                onSelect={this.onSelect}
                                rfqActiveStatus={rfqActiveStatus}
                                branchId={branchId}
                                biddingType={biddingType}
                                user={user}
                                user_name_list={user_name_list || []}
                                contractType={contractType}
                            /> : <ApprovalMatrix 
                                status={this.state.rfqStatusFilter}
                                ammendmentData={ammendmentData}
                                ammendmentCount={ammendmentCount}
                                approveRejectAmmendment={this.approveRejectAmmendment}

                            />
                        }
                            </Fragment> 
                        }
                        </div>
                        <a href={this.state.downloadTrucksDetailsUrl} className="dNone" ref={(ref) => { this.downloadBiddingDetailsButton = ref; }}></a>
                    </div>
                </Sticky>}
            </div>
        );
  }
}

const mapStateToProps = ({rfq, common, constants, contracting}) => {
  return {
    rfqs: rfq.rfqs,
    creatingRFQ: rfq.createRFQ.dataSubmitting,
    systemTime: common.systemTime,
    rfqTypesList: constants.rfqTypes || [],
    loader: contracting.ammendmentDetails.loading,
    ammendmentData: contracting.ammendmentDetails.data,
    ammendmentCount: contracting.ammendmentDetails.count,
    broadcastMsgs: common.broadcastMsgs || [],
    branchesList: constants.branchesList || []
  };
};


export default connect(mapStateToProps)(Dashboard);
